<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style="z-index: 99999999;">
        <div class="relative w-full max-w-md">
            <div
                class="border-0 rounded-lg shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none"
                style="min-height: 300px;">
                        <!--header-->
                        <div
                            class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                            <h3 class="text-3xl font-semibold">
                                <span v-if="!themeUUID">Создать тему</span>
                                <span v-else>Обновить</span>
                            </h3>
                            <!-- v-on:click="modalClose"> -->
                            <button
                                class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none">
                                <span @click="closeModal"
                                    class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                    ×
                                </span>
                            </button>
                        </div>
                        <!--body-->

                        <div style="width: 100%;" class="relative px-3 flex-auto margin-t-15">
                            <div class='relative'>
                                <div class="relative">
                                    <div class="margin-bt-10">
                                        <h4>Название</h4>
                                    </div>
                                    <div class="form-group">
                                        <input type="text"
                                            class="h-10 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                            :value="title" @input="event => title = event.target.value" />
                                    </div>
                                </div>
                            </div>

                            <p style="margin: 20px auto;" class="inl-90 my-4 text-blueGray-500 text-lg leading-relaxed"></p>

                        </div>
                        <!--footer-->
                        <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                            <!-- v-on:click="modalClose"     -->
                            <button
                                class='bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                @click.prevent="saveModalData" type="button">
                                <span v-if="!themeUUID">Сохранить</span>
                                <span v-else>Обновить</span>
                            </button>
                            <button @click.prevent="closeModal"
                                class='bg-red-500 active:bg-red-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150'
                                type="button">
                                Закрыть
                            </button>
                        </div>
            </div>
        </div>
    </div>
</template>

<script>
import { API_CLIENT, HEADERS_TOKEN_JSON } from '@/const/uri';
import axios from 'axios';

export default {
    components: {
    },
    data() {
        return {
            dateStart: null,
            title: null,
            dateEnd: null,
            dateStarts: [],
        };
    },
    mounted() {
    },
    methods: {
        closeModal() {
            this.$parent.closeModal();
        },
        async saveModalData() {
            let url = '';
            if(!this.$props.themeUUID) {
                url = API_CLIENT.tsorThemes;
            } else {
                url = API_CLIENT.tsorThemes  +  this.$props.themeUUID  + '/';
            }
            await axios({
                method: !this.$props.themeUUID ?  "POST" : "PUT",
                params: {}, 
                data: {
                    title: this.title, 
                    uuid: this.$props.themeUUID,
                    course: this.$props.course,
                    subject: this.$props.subjectId,
                    index: this.index,
                },
                url: url,
                headers: HEADERS_TOKEN_JSON(),
            }).then((e) => {
                this.$parent.updateData(e.data.data);
                this.closeModal();
            }).catch(function (e) {
                console.log(e);
            });
        },
    },
    beforeMount() {
        if(this.$props.prevTitle) {
            this.title = this.$props.prevTitle;
        }
    }, 
    props: {
        startDays: {},
        year: {},
        modalKey: {},
        endDays: {},
        themeUUID: {},
        course: {},
        index: {},
        prevTitle: {},  
        modalData: {},
    },
}
</script>

<style></style>